<!--<fui-formation-navigation *ngIf="hasNavigation"></fui-formation-navigation>-->
<ng-content select="fui-formation-groups"></ng-content>

